export default __webpack_public_path__ + "static/media/asp-net-and-sql-developer-salary.1dee58bb.png";